import { gql } from "@apollo/client";

export const QUERY_USERS_VIEWING_PAGES = gql`
  query getUsersViewingPages {
    getUsersViewingPages {
      page
      viewers {
        user
        role
        connectionId
      }
    }
  }
`;

export const QUERY_CONNECTED_SERVICES = gql`
  query getConnectedServices {
    getConnectedServices {
      name
      connections
      deployments
    }
  }
`;

export const QUERY_SERVER_TIME = gql`
  query getServerTime {
    getServerTime {
      time
      timezone
    }
  }
`;

export const SUBSCRIBE_HEARTBEAT = gql`
  subscription heartbeat {
    heartbeat
  }
`;

export const SUBSCRIBE_NEW_SERVER_TIME_UPDATE = gql`
  subscription newServerTimeUpdate {
    newServerTimeUpdate {
      time
      timezone
    }
  }
`;

export const SUBSCRIBE_NEW_LOG_UPDATE = gql`
  subscription newLogUpdate {
    newLogUpdate {
      date
      type
      message
    }
  }
`;

export const SUBSCRIBE_NEW_USER_VIEWING_PAGE_UPDATE = gql`
  subscription newUserViewingPageUpdate {
    newUserViewingPageUpdate {
      page
      user
      role
      connectionId
      status
    }
  }
`;

export const SUBSCRIBE_NEW_CONNECTED_SERVICE_UPDATE = gql`
  subscription newConnectedServiceUpdate {
    newConnectedServiceUpdate {
      name
      connections
      deployments
    }
  }
`;

export const QUERY_LAST_N_LOGS = gql`
  query getLastNLogs($n: Int!) {
    getLastNLogs(n: $n) {
      date
      type
      message
    }
  }
`;

export const QUERY_LOGS_BY_DATE_RANGE = gql`
  query getLogsByDateRange($startDate: Float!, $endDate: Float!) {
    getLogsByDateRange(startDate: $startDate, endDate: $endDate) {
      date
      type
      message
    }
  }
`;

export const MUTATE_USER_VIEWING_PAGE = gql`
  mutation userViewingPage(
    $page: String!
    $connectionId: String!
    $status: Boolean!
  ) {
    userViewingPage(page: $page, connectionId: $connectionId, status: $status)
  }
`;

export const MUTATE_CLOSE_SERVICE_CONNECTION = gql`
  mutation closeServiceConnection($serviceName: String!, $deployment: String!) {
    closeServiceConnection(serviceName: $serviceName, deployment: $deployment)
  }
`;

export const RESET_PROCESSED_WIN_TAX_VARS = gql`
  mutation ResetProcessedWinTAXVars($cars: [CarResetInput!]!) {
    resetProcessedWinTAXVars(cars: $cars) {
      success
      message
    }
  }
`;

export const RESET_AKS_DASHBOARD = gql`
  mutation ResetAKSDashboard {
    resetAKSDashboard
  }
`;

export const SUBSCRIBE_RESET_FRONTEND = gql`
  subscription resetFrontend {
    resetFrontend
  }
`;
